export default (props = {}) => ({
  /* background */
  [`bg-${props.bg}`]: props.bg,
  [`bg-${props.background}`]: props.background
});
